<svg
    width="279"
    height="200"
    viewBox="0 0 279 200"
    xmlns="http://www.w3.org/2000/svg">
    <svg:path
    class="single-roof"
    d="M274 101 L137 168 L0 101 L137 33 L274 101 Z" />
    <g app-helipad />
</svg>
